import {gql} from "@apollo/client";

export const CANCEL_PICKUP_APPOINTMENT = gql`
    mutation PickupAppointmentMutation($id: Long!, $cancelVoucherS3Keys: [String!]) {
        cancelPickupAppointment(id: $id, cancelVoucherS3Keys: $cancelVoucherS3Keys)
    }
`;

export interface CancelPickupAppointmentResponse {
    cancelPickupAppointment: boolean;
} 